/* Keep both cart displays in sync using the HTML already returned by Shopify.
 * Cart quantities, discounts, currency formatting and eligibility stay in Liquid.
 * No extra requests, polling or changes to the theme's cart handlers are needed.
 */
(() => {
  if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

  subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
    const sections = event?.cartData?.sections;
    if (!sections || event.cartData.errors) return;

    const selector = '[data-crest-shipping-progress]';
    let source;

    for (const markup of Object.values(sections)) {
      if (typeof markup !== 'string' || !markup.includes('data-crest-shipping-progress')) continue;
      source = new DOMParser().parseFromString(markup, 'text/html').querySelector(selector);
      if (source) break;
    }

    // A failed section response must not replace valid content with an empty bar.
    if (!source) return;

    document.querySelectorAll(selector).forEach((target) => {
      if (target.isEqualNode(source)) return;
      target.hidden = source.hidden;
      target.innerHTML = source.innerHTML;
    });
  });
})();
